import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";

const Contact_me = () => {
  const formRef = useRef();
  const [messageSent, setMessageSent] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    message: "",
  });

  // Initialize EmailJS
  useEffect(() => {
    emailjs.init("_5WPD2zVgi_oAw6uy");
    console.log("EmailJS initialized");
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    console.log("Attempting to send email...");
    console.log("Form data:", formData);

    // Send email using EmailJS with send method instead of sendForm
    const templateParams = {
      from_name: formData.user_name,
      from_email: formData.user_email,
      message: formData.message,
      to_name: "Mohammed Junaid Hussain",
    };

    emailjs
      .send(
        "service_p90rhzb",
        "template_s1zdb9p",
        templateParams,
        "_5WPD2zVgi_oAw6uy"
      )
      .then(
        (result) => {
          console.log("Email sent successfully:", result);
          setFormData({ user_name: "", user_email: "", message: "" });
          setMessageSent(true);
          setIsSubmitting(false);
          setTimeout(() => setMessageSent(false), 5000);
        },
        (error) => {
          console.error("Email Error Details:", error);
          console.error("Error text:", error.text);
          console.error("Error status:", error.status);
          alert(
            `Failed to send message: ${
              error.text || "Please try again or email directly."
            }`
          );
          setIsSubmitting(false);
        }
      );
  };

  return (
    <div className="min-h-screen py-16 sm:py-24 md:py-32 px-4 sm:px-6 text-white relative overflow-hidden">
      {/* Subtle grid background */}
      <div className="absolute inset-0 opacity-[0.015]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)`,
            backgroundSize: "60px 60px",
          }}
        ></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10">
        {/* Section indicator */}
        <div className="flex items-center gap-3 sm:gap-4 mb-10 sm:mb-14 md:mb-16">
          <div className="w-1 h-1 rounded-full bg-white/30"></div>
          <span className="text-white/30 text-xs tracking-[0.2em] sm:tracking-[0.3em] uppercase font-light">
            Get In Touch
          </span>
          <div className="h-[1px] flex-1 bg-gradient-to-r from-white/10 to-transparent"></div>
        </div>

        <div className="grid lg:grid-cols-5 gap-10 sm:gap-12 md:gap-16">
          {/* Left: Contact Info */}
          <div className="lg:col-span-2 space-y-8 sm:space-y-10 md:space-y-12">
            {/* Main heading */}
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-extralight text-white/90 mb-3 sm:mb-4">
                Let's Connect
              </h2>
              <p className="text-white/40 font-light text-base sm:text-base leading-relaxed">
                Have a project in mind or want to collaborate? Feel free to
                reach out—I'm always open to discussing new opportunities and
                ideas.
              </p>
            </div>

            {/* Contact details */}
            <div className="space-y-6">
              {/* Email */}
              <div className="group">
                <div
                  className="flex items-start gap-4 p-4 rounded-xl bg-white/[0.01] border border-white/[0.04]
                              hover:bg-white/[0.02] hover:border-white/[0.08] transition-all duration-500"
                >
                  <div className="mt-1">
                    <svg
                      className="w-5 h-5 text-white/20 group-hover:text-white/30 transition-colors duration-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  <div>
                    <p className="text-white/20 text-xs uppercase tracking-wider mb-1">
                      Email
                    </p>
                    <a
                      href="mailto:junaidhussain798@outlook.com"
                      className="text-white/50 group-hover:text-white/70 transition-colors duration-500 text-sm"
                    >
                      junaidhussain798@outlook.com
                    </a>
                  </div>
                </div>
              </div>

              {/* Location */}
              <div className="group">
                <div
                  className="flex items-start gap-4 p-4 rounded-xl bg-white/[0.01] border border-white/[0.04]
                              hover:bg-white/[0.02] hover:border-white/[0.08] transition-all duration-500"
                >
                  <div className="mt-1">
                    <svg
                      className="w-5 h-5 text-white/20 group-hover:text-white/30 transition-colors duration-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  </div>
                  <div>
                    <p className="text-white/20 text-xs uppercase tracking-wider mb-1">
                      Location
                    </p>
                    <p className="text-white/50 text-sm">Bangalore, India</p>
                  </div>
                </div>
              </div>

              {/* Social Links - Desktop */}
              <div className="hidden lg:block pt-6 border-t border-white/[0.04]">
                <p className="text-white/20 text-xs uppercase tracking-wider mb-4">
                  Connect
                </p>
                <div className="flex gap-3">
                  {[
                    {
                      icon: "linkedin",
                      href: "https://linkedin.com/in/junaid798",
                    },
                    {
                      icon: "github",
                      href: "https://github.com/Mohammed-Junaid-Hussain",
                    },
                    {
                      icon: "leetcode",
                      href: "https://leetcode.com/u/Juniad-Hussain",
                    },
                  ].map((social) => (
                    <a
                      key={social.icon}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 flex items-center justify-center rounded-full bg-white/[0.02] 
                               border border-white/[0.06] hover:bg-white/[0.04] hover:border-white/[0.12]
                               transition-all duration-500 group"
                    >
                      <span className="text-white/30 group-hover:text-white/50 transition-colors duration-500 text-xs uppercase">
                        {social.icon === "linkedin"
                          ? "in"
                          : social.icon === "github"
                          ? "gh"
                          : "lc"}
                      </span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="lg:col-span-3">
            <div className="relative">
              {/* Success Message */}
              {messageSent && (
                <div className="absolute -top-16 left-0 right-0 z-20 animate-slideDown">
                  <div className="p-4 bg-white/[0.03] border border-white/[0.08] rounded-xl backdrop-blur-xl">
                    <div className="flex items-center gap-3">
                      <svg
                        className="w-5 h-5 text-white/50"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span className="text-white/50 text-sm font-light">
                        Message sent successfully
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <form ref={formRef} onSubmit={handleSubmit} className="space-y-6">
                {/* Name Field */}
                <div className="relative">
                  <label
                    className={`block mb-2 text-xs uppercase tracking-wider transition-colors duration-300 ${
                      focusedField === "name"
                        ? "text-white/50"
                        : "text-white/20"
                    }`}
                  >
                    Name
                  </label>
                  <input
                    type="text"
                    name="user_name"
                    value={formData.user_name}
                    onChange={handleChange}
                    onFocus={() => setFocusedField("name")}
                    onBlur={() => setFocusedField(null)}
                    required
                    className="w-full px-5 py-4 rounded-xl bg-white/[0.02] border border-white/[0.06] 
                             text-white/70 placeholder-white/20 font-light
                             focus:bg-white/[0.03] focus:border-white/[0.12] focus:outline-none
                             transition-all duration-500"
                    placeholder="Your name"
                  />
                </div>

                {/* Email Field */}
                <div className="relative">
                  <label
                    className={`block mb-2 text-xs uppercase tracking-wider transition-colors duration-300 ${
                      focusedField === "email"
                        ? "text-white/50"
                        : "text-white/20"
                    }`}
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    name="user_email"
                    value={formData.user_email}
                    onChange={handleChange}
                    onFocus={() => setFocusedField("email")}
                    onBlur={() => setFocusedField(null)}
                    required
                    className="w-full px-5 py-4 rounded-xl bg-white/[0.02] border border-white/[0.06] 
                             text-white/70 placeholder-white/20 font-light
                             focus:bg-white/[0.03] focus:border-white/[0.12] focus:outline-none
                             transition-all duration-500"
                    placeholder="you@email.com"
                  />
                </div>

                {/* Message Field */}
                <div className="relative">
                  <label
                    className={`block mb-2 text-xs uppercase tracking-wider transition-colors duration-300 ${
                      focusedField === "message"
                        ? "text-white/50"
                        : "text-white/20"
                    }`}
                  >
                    Message
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    onFocus={() => setFocusedField("message")}
                    onBlur={() => setFocusedField(null)}
                    required
                    rows="6"
                    className="w-full px-5 py-4 rounded-xl bg-white/[0.02] border border-white/[0.06] 
                             text-white/70 placeholder-white/20 font-light resize-none
                             focus:bg-white/[0.03] focus:border-white/[0.12] focus:outline-none
                             transition-all duration-500"
                    placeholder="Your message..."
                  />
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="group relative w-full px-8 py-4 overflow-hidden rounded-xl disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <div
                    className="absolute inset-0 bg-white/[0.03] border border-white/[0.08] rounded-xl
                                group-hover:bg-white/[0.05] group-hover:border-white/[0.15] 
                                transition-all duration-500"
                  ></div>
                  <span
                    className="relative text-white/60 group-hover:text-white/80 text-sm tracking-wider 
                                 uppercase font-light transition-colors duration-500 flex items-center justify-center gap-2"
                  >
                    {isSubmitting ? (
                      <>
                        <svg
                          className="w-4 h-4 animate-spin"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Sending...
                      </>
                    ) : (
                      <>
                        Send Message
                        <svg
                          className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          />
                        </svg>
                      </>
                    )}
                  </span>
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Mobile Social Links */}
        <div className="lg:hidden mt-12 pt-8 border-t border-white/[0.04]">
          <p className="text-white/20 text-xs uppercase tracking-wider mb-6 text-center">
            Connect With Me
          </p>
          <div className="flex justify-center gap-4">
            {[
              {
                abbr: "EM",
                label: "Email",
                href: "mailto:junaidhussain798@outlook.com",
              },
              {
                abbr: "LI",
                label: "LinkedIn",
                href: "https://linkedin.com/in/junaid798",
              },
              {
                abbr: "GH",
                label: "GitHub",
                href: "https://github.com/Mohammed-Junaid-Hussain",
              },
              {
                abbr: "LC",
                label: "LeetCode",
                href: "https://leetcode.com/u/Juniad-Hussain",
              },
            ].map((link) => (
              <a
                key={link.abbr}
                href={link.href}
                target={link.href.startsWith("mailto") ? "_self" : "_blank"}
                rel="noopener noreferrer"
                className="group flex flex-col items-center gap-2"
              >
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-full
                              bg-white/[0.02] border border-white/[0.06]
                              group-active:bg-white/[0.06] group-active:border-white/[0.12]
                              transition-all duration-300"
                >
                  <span
                    className="text-white/40 group-active:text-white/70 text-[10px] uppercase
                                 tracking-wider font-light transition-colors duration-300"
                  >
                    {link.abbr}
                  </span>
                </div>
                <span className="text-white/30 text-[9px] uppercase tracking-wider font-light">
                  {link.label}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Floating accent */}
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white/[0.008] blur-[150px] rounded-full"></div>

      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-slideDown {
          animation: slideDown 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default Contact_me;
